import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DataAccessLog, DataAccessLogCreate, DataAccessLogFilter } from '../data/dataAccessLog';

export function createDataAccessLogService(client: AxiosInstance) {
  return createCrudService<DataAccessLog, DataAccessLogCreate, DataAccessLogFilter>(
    client,
    '/audit/DataAccessLog',
    'id',
  );
}

export type DataAccessLogService = CrudService<DataAccessLog, DataAccessLogCreate, DataAccessLogFilter>;
